module.exports = __webpack_public_path__ + "img/horizontal_3_7_r_pp23_3016.a757ec1a.png";